import React from "react";
import { Outlet } from "react-router-dom";
import CaseStudySidebar from "@/layouts/sidebar";
import { SidebarInset, SidebarProvider } from "ui/components/sidebar";
import BreadcrumbNav from "../components/breadcrumb-nav";
import { PermissionProvider } from "contexts/permission";
import { UI_ACTION_PORTAL_ID } from "utils";

export default function Dashboard() {
  return (
    <PermissionProvider>
      <div className="w-full flex overflow-hidden max-h-dvh">
        <SidebarProvider
          name="main-sidebar"
          className="w-fit overflow-hidden max-h-dvh"
        >
          <CaseStudySidebar />
        </SidebarProvider>
        <SidebarInset className="w-full relative">
          <header className="sticky z-50 top-0 w-full bg-white">
            <div className="flex justify-between bg-white  items-center px-4 h-12 md:h-16 shrink-0  transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12 border-b border-border">
              <div className="flex items-center gap-2">
                <BreadcrumbNav />
              </div>
              <div
                id={UI_ACTION_PORTAL_ID}
                className="flex gap-4 items-center"
              />
            </div>
          </header>
          <div>
            {/* <CommandAction /> */}
            <Outlet />
          </div>
        </SidebarInset>
      </div>
    </PermissionProvider>
  );
}
